<template>
  <form id="invite-user" @submit.prevent="inviteUser">
    <h1 class="title">Convite de usuário</h1>
    <p class="subtitle">
    </p>

    <div class="alert -danger" v-if="errors.unrecognized">
      <p class="title">Ops!</p>

      <p>Ocorreu um erro ao redefinir sua senha, tente novamente.</p>
    </div>

    <div class="alert -danger" v-if="errors.not_found">
      <p class="title">Ops!</p>

      <p>Convite não encontrado.</p>

      <p>Já é cadastrado? <router-link to="/login">Faça login</router-link>.</p>
    </div>

    <div class="alert -success" v-if="finished">
      <p>Seu usuário foi criado com sucesso, <router-link to="/login">faça login</router-link>.</p>
    </div>

    <div v-if="!errors.not_found && !finished">
      <div class="form-group">
        <label for="company_name" class="label">Nome da Empresa</label>
        <input
          class="form-control"
          id="company_name"
          type="text"
          placeholder="Nome da Empresa"
          v-model="invite.organizationName"
          disabled
        >
      </div>

      <div class="form-group">
        <label for="name" class="label">Seu nome</label>
        <input
          class="form-control"
          id="name"
          type="text"
          placeholder="Nome"
          v-model="invite.name"
          disabled
        >
      </div>

      <div class="form-group" :class="{'-has-error': errors.form.cpf.length > 0}">
        <label for="cpf" class="label">Seu CPF</label>
        <input
          class="form-control"
          id="cpf"
          type="text"
          placeholder="CPF"
          v-model="form.cpf"
          v-mask="'###.###.###-##'"
          autocomplete
          required
        >
        <p class="description" v-if="errors.form.cpf.length > 0">{{ errors.form.cpf[0] }}</p>
      </div>

      <div class="form-group" :class="{'-has-error': errors.form.phone.length > 0}">
        <label for="phone" class="label">Seu Telefone</label>
        <input
          class="form-control"
          id="phone"
          type="tel"
          placeholder="Telefone"
          v-model="form.phone"
          v-mask="['(##) ####-####', '(##) #####-####']"
          autocomplete
          required
        >
        <p class="description" v-if="errors.form.phone.length > 0">{{ errors.form.phone[0] }}</p>
      </div>

      <div class="form-group">
        <label for="email" class="label">E-mail</label>
        <input
          class="form-control"
          id="email"
          type="email"
          placeholder="Email"
          v-model="invite.email"
          disabled
        >
      </div>

      <div class="form-group" :class="{'-has-error': errors.form.password.length > 0}">
        <label for="password" class="label">Senha</label>
        <input
          class="form-control"
          id="password"
          type="password"
          placeholder="******************"
          autocomplete
          v-model="form.password"
          required
        >
        <p class="description" v-if="errors.form.password.length > 0">{{ errors.form.password[0] }}</p>
      </div>

      <div class="form-group">
        <label for="password_confirmation" class="label">Confirmar senha</label>
        <input
          class="form-control"
          id="password_confirmation"
          type="password"
          placeholder="******************"
          autocomplete
          v-model="form.password_confirmation"
          required
        >
      </div>

      <div class="form-group">
        <div class="form-check">
          <input
            type="checkbox"
            class="form-check-input"
            id="accept-terms"
            name="accept-terms"
            required
          >
          <label
            for="accept-terms"
            class="form-check-label"
          >Eu aceito os <a :href="dashboardConfig.legal.terms" target="_blank">Termos de uso</a> e a <a :href="dashboardConfig.legal.privacy" target="_blank">Política de privacidade</a>.</label>
        </div>
      </div>

      <div class="actions">
        <button class="btn btn-primary -full-width" type="submit">
          Enviar
        </button>
      </div>
    </div>

    <loader
      background="#FFF"
      v-if="loading"/>
  </form>
</template>

<script>
import { mask } from 'vue-the-mask';
import Loader from '@/support/components/Loader.vue';
import checkErrorIsUnrecognizedResponse from '@/support/helpers/checkErrorIsUnrecognizedResponse';
import { mapState } from 'vuex';

export default {
  name: 'InviteUser',

  data() {
    return {
      form: {
        cpf: '',
        phone: '',
        password: '',
        password_confirmation: '',
      },

      finished: false,
      loading: false,

      errors: {
        unrecognized: false,
        not_found: false,
        form: {
          cpf: [],
          phone: [],
          password: [],
          password_confirmation: [],
        },
      },
    };
  },

  methods: {
    /**
     * Reset the password.
     *
     * @returns {Promise<void>}
     */
    async inviteUser() {
      try {
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/createUserByInvite', {
          ...this.form,
          token: this.$route.params.token,
        });

        this.resetFields();
        document.getElementById('invite-user').reset();
        this.finished = true;
      } catch (err) {
        if (checkErrorIsUnrecognizedResponse(err, [422])) {
          this.errors.unrecognized = true;

          return;
        }

        const { data, status } = err.response;

        if (status === 422) {
          this.errors.form.cpf = data.errors.cpf || [];
          this.errors.form.phone = data.errors.phone || [];
          this.errors.form.password = data.errors.password || [];
        }
      } finally {
        this.loading = false;
      }
    },

    async findInvite() {
      this.loading = true;

      try {
        await this.$store.dispatch('auth/findInvite', this.$route.params.token);
      } catch (err) {
        this.errors.not_found = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.form.password = [];
      this.errors.form.password_confirmation = [];
      this.errors.unrecognized = false;
      this.errors.not_found = false;
    },
    resetFields() {
      this.form.password = '';
      this.form.password_confirmation = '';
    },
  },

  mounted() {
    this.findInvite();
  },

  computed: {
    ...mapState('auth', {
      invite: 'invite',
    }),
    ...mapState('dashboard', [
      'dashboardConfig',
    ]),
  },

  directives: {
    mask,
  },

  components: {
    Loader,
  },
};
</script>

<style lang="scss" scoped>
  #reset-password {
    @apply relative;

    > .title {
      @apply text-xl;
      @apply font-bold;
      @apply text-secondary-700;
      letter-spacing: -0.01em;
      margin-bottom: 8px;
    }

    > .subtitle {
      @apply text-sm;
      @apply mb-5;
      @apply text-gray-800;
    }

    > .form-group {
      @apply mb-5;
    }

    > .actions {
      @apply mb-5;
    }

    > .callLogin {
      @apply text-sm;
      @apply mb-5;
      @apply text-gray-800;
    }
  }
</style>
